import { useDispatch } from "react-redux";

import type { AppDispatch } from "../../model/store";

/** `useDispatch` pre-bound to `AppDispatch` (understands thunks). */
export const useAppDispatch: () => AppDispatch = useDispatch;

export default useAppDispatch;
